<script lang="ts" setup>
    import { useClipboard } from '@vueuse/core'
    import { computed } from 'vue'
    import PkCode from './PkCode.vue'

    const props = withDefaults(
        defineProps<{
            source: string
            codeLanguage?: string
            modifiers?: string | string[]
        }>(),
        {
            codeLanguage: undefined,
            modifiers: () => [],
        },
    )

    const source = computed(() => props.source.trim())

    const { copy, copied } = useClipboard({
        source,
    })

    const modifiersClasses = computed(() => {
        const modifiers = Array.isArray(props.modifiers)
            ? props.modifiers
            : (props.modifiers?.split(' ') ?? [])
        return modifiers.map((mod) => `pk-copy-block--${mod}`)
    })
</script>

<template>
    <div :class="['pk-copy-block', ...modifiersClasses]">
        <slot>
            <PkCode
                v-if="codeLanguage"
                :code="source"
                :language="codeLanguage" />
            <div v-else>{{ source }}</div>
        </slot>
        <div class="pk-copy-block__actions">
            <VvButtonGroup>
                <VvButton
                    :modifiers="
                        !modifiers.includes('inline')
                            ? 'action-small'
                            : 'action-quiet-small'
                    "
                    :icon="copied ? 'ri:check-line' : 'ri:file-copy-line'"
                    :label="
                        !modifiers.includes('inline')
                            ? copied
                                ? $t('action.copied')
                                : $t('action.copy')
                            : undefined
                    "
                    @click="copy()" />
                <slot name="actions" />
            </VvButtonGroup>
        </div>
    </div>
</template>

<style lang="scss">
    .pk-copy-block {
        position: relative;
        overflow: hidden;

        &:not(.pk-copy-block--simple) {
            border-radius: var(--rounded-md);
            border: 1px solid var(--color-surface-3);
        }

        &__actions {
            border: 1px soli var(--color-surface-3);
            padding: var(--spacing-xs);
        }

        &--inline {
            display: flex;
            gap: var(--spacing-xs);
            align-items: center;

            & .pk-copy-block__actions {
                border: none;
                padding-block: var(--spacing-4);
                padding-inline: var(--spacing-8);
                margin-left: auto;
            }
        }
    }
</style>
